module.exports = __webpack_public_path__ + "img/photo03.444d6838.jpg";